import React from 'react';
import getHighlightedText from '@medflex/utils/getHighlightedText';
import PropTypes from 'prop-types';

const SearchHighlight = ({ text, toHighlight }) => {
  const highlightedHtml = getHighlightedText(text, toHighlight);

  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: highlightedHtml }} />;
};

SearchHighlight.defaultProps = {
  text: '',
  toHighlight: '',
};

SearchHighlight.propTypes = {
  text: PropTypes.string,
  toHighlight: PropTypes.string,
};

export default SearchHighlight;
